// extracted by mini-css-extract-plugin
module.exports = {"root":"buttonPrimary_root__2izuF"};